import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AlertsToastsService } from '../services/alerts-toasts.service';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-add-device',
  templateUrl: './add-device.page.html',
  styleUrls: ['./add-device.page.scss'],
})
export class AddDevicePage implements OnInit {
  isCreated: boolean;
  deviceId: any;
  constructor(
    private modalController: ModalController,
    private httpService: HttpService,
    private alertsToasts: AlertsToastsService
  ) {}

  addDeviceForm = new FormGroup({
    area: new FormControl('', Validators.required),
    location: new FormControl('', Validators.required),
  });

  ionViewWiilEnter() {
    this.isCreated = false;
  }

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }

  submit() {
    this.httpService.doPost('/addDevice', this.addDeviceForm.value).subscribe({
      next: (data: any) => {
        if (data.success) {
          this.alertsToasts.presentToast('Device Created');
          this.isCreated = true;
          this.deviceId = data.data._id;
        }
      },
      error: (err) => {
        console.log(err);
        let toastMessage: string;
        err.error.message ? (toastMessage = err.error.message) : err.message;
        this.alertsToasts.presentToast(toastMessage);
      },
    });
  }
}
